import React, { useCallback } from 'react';
import PropTypes from 'propTypes';
import styled from '@emotion/styled';
import TextField from './TextField';

const MenuProps = {
  variant: 'menu',
  PaperProps: {
    sx: {
      maxHeight: 500,
      maxWidth: '50vw',
      'li > span': {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  },
};

const Placeholder = styled('span')`
  color: #aaa;
`;

const emptyArray = [];

const SelectField = ({ displayEmpty, renderValue: $renderValue, disableUnderline, variant, native, SelectProps, placeholder, ...args }) => {

  const renderPlaceholder = useCallback(() => <Placeholder>{placeholder}</Placeholder>, [placeholder]);

  // MUI throws when a multiple select is handed anything but an array
  const value = args.multiple && !Array.isArray(args.value) ? emptyArray : args.value;

  // Placeholder not easily and by default supported with select.
  // Add basic implementation which hopefully doesn't cause additional problems.
  // When has no value, but a placeholder, then display the placeholder.
  const renderValue = !$renderValue && !!placeholder && !value && !value?.length
    ? renderPlaceholder
    : $renderValue;

  return (
    <TextField
      select
      variant={variant}
      SelectProps={{
        ...(renderValue && { renderValue }),
        ...(displayEmpty && { displayEmpty }),
        ...(disableUnderline && { disableUnderline }),
        ...(variant && { variant }),
        ...(native && { native }),
        ...(MenuProps && { MenuProps }),
        ...(SelectProps || {}),
      }}
      {...args}
      value={value}
    />
  );
};

SelectField.propTypes = {
  displayEmpty: PropTypes.bool,
  renderValue: PropTypes.func,
  disableUnderline: PropTypes.bool,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  native: PropTypes.bool,
  SelectProps: PropTypes.object,
  placeholder: PropTypes.string,
};

export default SelectField;
